<div class="flex flex-col gap-2">
    <!----------------------------------------------------------------------------->
    <!-- Invoice Data -->
    <app-drop-down-section #invoiceDataDropdown title="{{ 'admin.invoice_data' | transloco }}"
        titleIcon="assets/icons/admin/file-black.svg" [sectionId]="'invoice-data'" [enableFloatingActiong]="true">
        <!-- Actions-->
        <app-edit-cancel-button header-actions [isEditing]="isEditingInvoiceData" [isSaving]="savingInvoice"
            (edit)="editInvoiceData()" (cancel)="cancelEditInvoiceData()"
            (save)="saveEditInvoiceData()"></app-edit-cancel-button>

        <!-- Body -->
        <table class="table w-full">
            <!-- Header -->
            <thead class="bg-neutral-100 text-neutral-700 uppercase">
                <tr class="max-h-[50px]">
                    <th class="border-b border-border px-4 py-4 font-normal">{{ 'admin.description' |
                        transloco
                        }}</th>
                    <th class="border-b border-border px-4 py-4 font-normal">{{ 'admin.extraction' |
                        transloco
                        }}</th>
                </tr>
            </thead>
            <!-- Content -->
            <tbody>
                <!-- For Period -->
                <tr class="max-h-[50px]">
                    <td class="border-b border-border px-4 py-4">
                        <div class="flex gap-2 items-center">
                            <p>{{ 'invoice.labels.period' | transloco }}</p>
                            <app-invoice-variable-status
                                [status]="checkMandatoryVariableEmptyStatus(forPeriodDate, true)"></app-invoice-variable-status>
                        </div>
                    </td>
                    <td class="border-b border-border px-4 py-4">
                        <div class="min-w-[250px]">
                            <app-custom-date-input inputId="forPeriod"
                                placeholder="{{ 'invoice.placeholders.period' | transloco }}" autoMarginTop="mt-0"
                                [showOnlyValueWhenDisabled]="true" [(dateValue)]="forPeriodDate"
                                [errorMessage]="forPeriodInputError" dateFormat="mm/yy" boxHeight="h-[40px]"
                                [isDisabled]="!isEditingInvoiceData">
                            </app-custom-date-input>
                        </div>

                        @if(!isEditingInvoiceData && checkMandatoryVariableEmptyStatus(forPeriodDate, true) ==
                        InvoiceVariableStatus.MANDATORY_FIELD_MISSING){
                        <app-mandatory-data-missing (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                        }
                    </td>
                </tr>

                <!-- Invoice number -->
                <tr class="max-h-[50px]">
                    <td class="border-b border-border px-4 py-4">
                        <div class="flex gap-2 items-center">
                            <p>{{ 'invoice.labels.number' | transloco }}</p>
                            <app-invoice-variable-status
                                [status]="checkVariableEmptyStatus(invoiceNumberInput, true)"></app-invoice-variable-status>
                        </div>
                    </td>
                    <td class="border-b border-border px-4 py-4">
                        <div class="min-w-[250px]">
                            <app-labeled-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                [isDisabled]="!isEditingInvoiceData" [inputId]="'invoiceNumber'" autoMarginTop="mt-0"
                                [inputType]="'text'" [(inputValue)]="invoiceNumberInput"
                                [errorMessage]="invoiceNumberInputError"
                                placeholder="{{ 'invoice.placeholders.number' | transloco }}">
                            </app-labeled-input>
                        </div>

                        @if(!isEditingInvoiceData && checkMandatoryVariableEmptyStatus(invoiceNumberInput, true) ==
                        InvoiceVariableStatus.MANDATORY_FIELD_MISSING){
                        <app-mandatory-data-missing (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                        }
                    </td>
                </tr>

                <!-- Invoice amount actual -->
                <tr class="max-h-[50px]">
                    <td class="border-b border-border px-4 py-4">
                        <div class="flex gap-2 items-center">
                            <p>{{ 'invoice.labels.amount_actual' | transloco }}</p>
                            <app-invoice-variable-status
                                [status]="checkMandatoryVariableEmptyStatus(invoiceAmountActualInput, true)"></app-invoice-variable-status>
                        </div>
                    </td>
                    <td class="border-b border-border px-4 py-4">
                        <div class="min-w-[250px]">
                            <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                [isDisabled]="!isEditingInvoiceData" [inputId]="'invoiceAmountActual'"
                                autoMarginTop="mt-0" [inputType]="'number'" [(inputValue)]="invoiceAmountActualInput"
                                [errorMessage]="invoiceAmountActualInputError"
                                [warningMessage]="invoiceAmountActualInputWarning"
                                placeholder="{{ 'invoice.placeholders.amount' | transloco }}"
                                (inputValueLength)="onFieldChange({ value: $event, fieldName: 'invoiceAmountActual' })">
                            </app-custom-number-input>
                        </div>

                        @if(!isEditingInvoiceData && checkMandatoryVariableEmptyStatus(invoiceAmountActualInput, true)
                        ==
                        InvoiceVariableStatus.MANDATORY_FIELD_MISSING){
                        <app-mandatory-data-missing (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                        }
                    </td>
                </tr>

                <!-- Total consumption  -->
                <tr class="max-h-[50px]">
                    <td class="border-b border-border px-4 py-4">
                        <div class="flex gap-2 items-center">
                            <p>{{ 'invoice.labels.total_consumption' | transloco }} Smc</p>
                            <app-invoice-variable-status
                                [status]="checkMandatoryVariableEmptyStatus(totalConsumptionInput, true)"></app-invoice-variable-status>
                        </div>
                    </td>
                    <td class="border-b border-border px-4 py-4">
                        <div class="min-w-[250px]">
                            <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                [isDisabled]="!isEditingInvoiceData" autoMarginTop="mt-0" [inputId]="'totalConsumption'"
                                [inputType]="'number'" [(inputValue)]="totalConsumptionInput"
                                [errorMessage]="totalConsumptionInputError"
                                [warningMessage]="totalConsumptionInputWarning"
                                placeholder="{{ 'invoice.placeholders.total_consumption' | transloco }}"
                                (inputValueLength)="onFieldChange({ value: $event, fieldName: 'totalConsumption'})">
                            </app-custom-number-input>
                        </div>

                        @if(!isEditingInvoiceData && checkMandatoryVariableEmptyStatus(totalConsumptionInput, true) ==
                        InvoiceVariableStatus.MANDATORY_FIELD_MISSING){
                        <app-mandatory-data-missing (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                        }
                    </td>
                </tr>

                <!-- Invoice amount gross -->
                <tr class="max-h-[50px]">
                    <td class="border-b border-border px-4 py-4">
                        <div class="flex gap-2 items-center">
                            <p>{{ 'invoice.labels.amount_gross' | transloco }}</p>
                            <app-invoice-variable-status
                                [status]="checkVariableEmptyStatus(invoiceAmountGrossInput, true)"></app-invoice-variable-status>
                        </div>
                    </td>
                    <td class="border-b border-border px-4 py-4">
                        <div class="min-w-[250px]">
                            <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                [isDisabled]="!isEditingInvoiceData" [inputId]="'invoiceAmountGross'"
                                autoMarginTop="mt-0" [inputType]="'number'" [(inputValue)]="invoiceAmountGrossInput"
                                [errorMessage]="invoiceAmountGrossInputError"
                                placeholder="{{ 'invoice.placeholders.amount' | transloco }}">
                            </app-custom-number-input>
                        </div>

                        @if(!isEditingInvoiceData && checkMandatoryVariableEmptyStatus(invoiceAmountGrossInput, true) ==
                        InvoiceVariableStatus.MANDATORY_FIELD_MISSING){
                        <app-mandatory-data-missing (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                        }
                    </td>
                </tr>

                <!-- Invoice nontaxable amount -->
                <tr class="max-h-[50px]">
                    <td class="border-b border-border px-4 py-4">
                        <div class="flex gap-2 items-center">
                            <p>{{ 'invoice.labels.nontaxable_amount' | transloco }}</p>
                            <app-invoice-variable-status
                                [status]="checkVariableEmptyStatus(nontaxableAmountInput, true)"></app-invoice-variable-status>
                        </div>
                    </td>
                    <td class="border-b border-border px-4 py-4">
                        <div class="min-w-[250px]">
                            <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                [isDisabled]="!isEditingInvoiceData" [inputId]="'nontaxableAmount'" autoMarginTop="mt-0"
                                [inputType]="'number'" [(inputValue)]="nontaxableAmountInput"
                                [errorMessage]="nontaxableAmountInputError">
                            </app-custom-number-input>
                        </div>

                        @if(!isEditingInvoiceData && checkMandatoryVariableEmptyStatus(nontaxableAmountInput, true) ==
                        InvoiceVariableStatus.MANDATORY_FIELD_MISSING){
                        <app-mandatory-data-missing (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                        }
                    </td>
                </tr>
            </tbody>
        </table>
    </app-drop-down-section>

    <!----------------------------------------------------------------------------->
    <!-- PDRs -->
    <app-drop-down-section #pdrSection (openedChange)="onPdrSectionOpenedChange(i, $event)"
        *ngFor="let pdr of invoice?.pdrs; let i = index"
        title="{{ 'invoice.sections.pdr_number' | transloco }} {{ i + 1}}"
        titleIcon="assets/icons/admin/power-black.svg" [sectionId]="'pdr-' + i" [enableFloatingActiong]="true">

        <!-- Actions-->
        <app-edit-cancel-button header-actions [isEditing]="isEditingInvoiceData" [isSaving]="savingInvoice"
            (edit)="editInvoiceData()" (cancel)="cancelEditInvoiceData()"
            (save)="saveEditInvoiceData()"></app-edit-cancel-button>

        <!-- Body -->
        <table class="table w-full">
            <!-- Header -->
            <thead class="bg-neutral-100 text-neutral-700 uppercase">
                <tr class="max-h-[50px]">
                    <th class="border-b border-border px-4 py-4 font-normal">{{ 'admin.description' |
                        transloco
                        }}</th>
                    <th class="border-b border-border px-4 py-4 font-normal">{{ 'admin.extraction' |
                        transloco
                        }}</th>
                </tr>
            </thead>
            <!-- Content -->
            <tbody>
                <!-- GAS PDR ID -->
                <tr class="max-h-[50px]">
                    <td class="border-b border-border px-4 py-4">
                        <div class="flex gap-2 items-center">
                            <p>{{ 'shared.labels.gas.pdr_id' | transloco }}</p>
                            <app-invoice-variable-status
                                [status]="checkMandatoryVariableEmptyStatus(editedPDRs[i].pdr_id, true)"></app-invoice-variable-status>
                        </div>
                    </td>
                    <td class="border-b border-border px-4 py-4">
                        <div class="min-w-[250px]">
                            <app-labeled-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                [isDisabled]="!isEditingInvoiceData" [inputId]="'pdr_id' + i" autoMarginTop="mt-0"
                                [(inputValue)]="editedPDRs[i].pdr_id"
                                placeholder="{{ 'shared.placeholders.gas.pdr_id' | transloco }}"
                                [warningMessage]="pdrIdInputWarnings[i]"
                                (inputValueLength)="onFieldChange({ value: $event, targetArray: pdrIdInputWarnings, pdrIndex: i})">
                            </app-labeled-input>
                        </div>
                    </td>
                </tr>

                <!-- Invoice price type -->
                <tr class="max-h-[50px]">
                    <td class="border-b border-border px-4 py-4">
                        <div class="flex gap-2 items-center">
                            <p>{{ 'invoice.labels.price_type' | transloco }}</p>
                            <app-invoice-variable-status
                                [status]="checkMandatoryVariableEmptyStatus(editedPDRs[i].selectedPriceTypeDropdown, true)"></app-invoice-variable-status>
                        </div>
                    </td>
                    <td class="border-b border-border px-4 py-4">
                        <div class="min-w-[250px]">
                            <app-custom-dropdown [options]="priceTypeDropdownOptions" [showOnlyValueWhenDisabled]="true"
                                [(selectedOption)]="editedPDRs[i].selectedPriceTypeDropdown" [disabled]="saveClicked"
                                [warningMessage]="priceTypeDropdownWarning[i]"
                                (selectedOptionChange)="onPriceTypeChange(i)" [disabled]="!isEditingInvoiceData"
                                boxHeight="h-[40px]" autoMarginTop="mt-0">
                            </app-custom-dropdown>
                        </div>
                    </td>
                </tr>

                <!-- Gas market index -->
                <tr class="max-h-[50px]">
                    <td class="border-b border-border px-4 py-4">
                        <div class="flex gap-2 items-center">
                            <p>{{ 'invoice.labels.gas_market_index' | transloco }}</p>
                            <app-invoice-variable-status
                                [status]="checkVariableEmptyStatus(editedPDRs[i].gas_market_index, true)"></app-invoice-variable-status>
                        </div>
                    </td>
                    <td class="border-b border-border px-4 py-4">
                        <div class="min-w-[250px]">
                            <app-labeled-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                [isDisabled]="!isEditingInvoiceData" [inputId]="'gas_market_index_' + i"
                                autoMarginTop="mt-0" [(inputValue)]="editedPDRs[i].gas_market_index">
                            </app-labeled-input>
                        </div>
                    </td>
                </tr>

                <!-- Gas intensity class -->
                <tr class="max-h-[50px]">
                    <td class="border-b border-border px-4 py-4">
                        <div class="flex gap-2 items-center">
                            <p>{{ 'invoice.labels.gas_intensity_class' | transloco }}</p>
                            <app-invoice-variable-status
                                [status]="checkMandatoryVariableEmptyStatus(editedPDRs[i].gas_intensity_class, true)"></app-invoice-variable-status>
                        </div>
                    </td>
                    <td class="border-b border-border px-4 py-4">
                        <div class="min-w-[250px]">
                            <app-labeled-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                [isDisabled]="!isEditingInvoiceData" [inputId]="'gas_intensity_class_' + i"
                                autoMarginTop="mt-0" [(inputValue)]="editedPDRs[i].gas_intensity_class"
                                [warningMessage]="gasIntensityClassInputWarnings[i]"
                                (inputValueLength)="onFieldChange({ value: $event, targetArray: gasIntensityClassInputWarnings, pdrIndex: i})">
                            </app-labeled-input>
                        </div>
                    </td>
                </tr>

                <!-- Gas meter class -->
                <tr class="max-h-[50px]">
                    <td class="border-b border-border px-4 py-4">
                        <div class="flex gap-2 items-center">
                            <p>{{ 'invoice.labels.gas_meter_class' | transloco }}</p>
                            <app-invoice-variable-status
                                [status]="checkMandatoryVariableEmptyStatus(editedPDRs[i].gas_meter_class, true)"></app-invoice-variable-status>
                        </div>
                    </td>
                    <td class="border-b border-border px-4 py-4">
                        <div class="min-w-[250px]">
                            <app-labeled-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                [isDisabled]="!isEditingInvoiceData" [inputId]="'gas_meter_class_' + i"
                                autoMarginTop="mt-0" [(inputValue)]="editedPDRs[i].gas_meter_class"
                                [warningMessage]="gasMeterClassInputWarnings[i]"
                                (inputValueLength)="onFieldChange({ value: $event, targetArray: gasMeterClassInputWarnings, pdrIndex: i})">
                            </app-labeled-input>
                        </div>
                    </td>
                </tr>

                <!-- REMI type -->
                <tr class="max-h-[50px]">
                    <td class="border-b border-border px-4 py-4">
                        <div class="flex gap-2 items-center">
                            <p>{{ 'invoice.labels.REMI_type_gas' | transloco }}</p>
                            <app-invoice-variable-status
                                [status]="checkMandatoryVariableEmptyStatus(editedPDRs[i].REMI_type_gas, true)"></app-invoice-variable-status>
                        </div>
                    </td>
                    <td class="border-b border-border px-4 py-4">
                        <div class="min-w-[250px]">
                            <app-labeled-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                [isDisabled]="!isEditingInvoiceData" [inputId]="'REMI_type_gas_' + i"
                                autoMarginTop="mt-0" [(inputValue)]="editedPDRs[i].REMI_type_gas"
                                [warningMessage]="remiTypeInputWarnings[i]"
                                (inputValueLength)="onFieldChange({ value: $event, targetArray: remiTypeInputWarnings, pdrIndex: i})">
                            </app-labeled-input>
                        </div>
                    </td>
                </tr>

                <!-- Tax Region -->
                <tr class="max-h-[50px]">
                    <td class="border-b border-border px-4 py-4">
                        <div class="flex gap-2 items-center">
                            <p>{{ 'invoice.labels.tax_region' | transloco }}</p>
                            <app-invoice-variable-status
                                [status]="checkMandatoryVariableEmptyStatus(editedPDRs[i].tax_region, true)"></app-invoice-variable-status>
                        </div>
                    </td>
                    <td class="border-b border-border px-4 py-4">
                        <div class="min-w-[250px]">
                            <app-labeled-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                [isDisabled]="true" [inputId]="'tax_region_' + i" autoMarginTop="mt-0"
                                [(inputValue)]="editedPDRs[i].tax_region" [warningMessage]="taxRegionInputWarnings[i]"
                                (inputValueLength)="onFieldChange({ value: $event, targetArray: taxRegionInputWarnings, pdrIndex: i})">
                            </app-labeled-input>
                        </div>
                    </td>
                </tr>

                <!-- Area -->
                <tr class="max-h-[50px]">
                    <td class="border-b border-border px-4 py-4">
                        <div class="flex gap-2 items-center">
                            <p>{{ 'invoice.labels.area_gas' | transloco }}</p>
                            <app-invoice-variable-status
                                [status]="checkMandatoryVariableEmptyStatus(editedPDRs[i].area_gas, true)"></app-invoice-variable-status>
                        </div>
                    </td>
                    <td class="border-b border-border px-4 py-4">
                        <div class="min-w-[250px]">
                            <app-labeled-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                [isDisabled]="!isEditingInvoiceData" [inputId]="'area_gas_' + i" autoMarginTop="mt-0"
                                [(inputValue)]="editedPDRs[i].area_gas" [warningMessage]="areaInputWarnings[i]"
                                (inputValueLength)="onFieldChange({ value: $event, targetArray: areaInputWarnings, pdrIndex: i})">
                            </app-labeled-input>
                        </div>
                    </td>
                </tr>

                <!-- Daily gas capacity -->
                <tr class="max-h-[50px]">
                    <td class="border-b border-border px-4 py-4">
                        <div class="flex gap-2 items-center">
                            <p>{{ 'invoice.labels.daily_gas_capacity' | transloco }}</p>
                            <!-- <app-invoice-variable-status [status]="checkVariableEmptyStatus(editedPDRs[i].daily_gas_capacity, true)"></app-invoice-variable-status> -->
                        </div>
                    </td>
                    <td class="border-b border-border px-4 py-4">
                        <div class="min-w-[250px]">
                            <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                [isDisabled]="!isEditingInvoiceData" [inputId]="'daily_gas_capacity_' + i"
                                autoMarginTop="mt-0" [(inputValue)]="editedPDRs[i].daily_gas_capacity">
                            </app-custom-number-input>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>

        <!-- Cost Component Analysis-->
        <div class="w-full p-2 flex flex-col gap-2 bg-neutral-100">
            <p class="text-lg font-bold">{{ 'admin.cost_component_analysis' | transloco }}</p>
            <div class="self-end flex gap-2 flex-wrap items-center">
                <p class="text-sm text-neutral-500">{{ 'admin.view_all_components' | transloco }}</p>
                <app-toggle-button [(toggleButton)]="viewAllComponents"></app-toggle-button>
            </div>

            <table class="table w-full rounded-md">
                <!-- Header -->
                <thead class="bg-neutral-200 text-black font-semibold uppercase">
                    <tr class="max-h-[50px]">
                        <th class="border-b border-border px-4 py-4">{{ 'admin.component_name' |
                            transloco
                            }}</th>
                        <th class="border-b border-border px-4 py-4">{{ 'admin.calculation' |
                            transloco
                            }} (€)</th>
                        <th class="border-b border-border px-4 py-4">{{ 'admin.extraction' |
                            transloco
                            }} (€)</th>
                        <th class="border-b border-border px-4 py-4">{{ 'admin.delta' |
                            transloco
                            }} (€)</th>
                    </tr>
                </thead>
                <!-- Content -->
                <tbody class="bg-[#FFFFFF]">
                    <!-- Material costs variable -->
                    <tr class="max-h-[50px] hover:bg-neutral-300 cursor-pointer"
                        (click)="isMaterialCostsCollapsed = !isMaterialCostsCollapsed">
                        <td class="border-b border-border px-4 py-4">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.</p>
                                <p>{{'invoice.material_costs' | transloco}}</p>
                                @if(getPriceType(editedPDRs[i].selectedPriceTypeDropdown) == PriceType.VAR)
                                {
                                <app-invoice-variable-status
                                    [status]="pdr?.calc_data?.material_costs_gas_variable_calc === null || pdr?.calc_data?.material_costs_gas_variable_calc === undefined
                                    ? checkMandatoryVariableEmptyStatus(pdr?.calc_data?.material_costs_gas_variable_calc)
                                    : checkMandatoryVariableEmptyStatus(editedPDRs[i].material_costs_gas_variable_actual)"></app-invoice-variable-status>
                                }
                                @else if(getPriceType(editedPDRs[i].selectedPriceTypeDropdown) == PriceType.FIX){
                                <app-invoice-variable-status
                                    [status]="pdr?.calc_data?.material_costs_gas_fixed_calc === null || pdr?.calc_data?.material_costs_gas_fixed_calc === undefined
                                    ? checkMandatoryVariableEmptyStatus(pdr?.calc_data?.material_costs_gas_fixed_calc)
                                    : checkMandatoryVariableEmptyStatus(editedPDRs[i].material_costs_gas_fixed_actual)"></app-invoice-variable-status>
                                }
                                <app-collapse-arrow [isOpen]="isMaterialCostsCollapsed"></app-collapse-arrow>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            @if(getPriceType(editedPDRs[i].selectedPriceTypeDropdown) == PriceType.VAR)
                            {
                            @if (safeValue(pdr?.calc_data?.material_costs_gas_variable_calc)) {
                            {{ safeValue(pdr?.calc_data?.material_costs_gas_variable_calc) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                            }
                            @else if(getPriceType(editedPDRs[i].selectedPriceTypeDropdown) == PriceType.FIX){
                            @if (safeValue(pdr?.calc_data?.material_costs_gas_fixed_calc)) {
                            {{ safeValue(pdr?.calc_data?.material_costs_gas_fixed_calc) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                            }
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                @if(getPriceType(editedPDRs[i].selectedPriceTypeDropdown) == PriceType.VAR)
                                {
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData"
                                    [inputId]="'material_costs_gas_variable_actual_' + i" [inputType]="'number'"
                                    autoMarginTop="mt-0" [inputType]="'number'"
                                    [(inputValue)]="editedPDRs[i].material_costs_gas_variable_actual"
                                    [warningMessage]="materialCostsGasVariableActualInputWarnings[i]"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: materialCostsGasVariableActualInputWarnings, pdrIndex: i, fieldName: 'material_costs_gas_variable_actual'})">
                                </app-custom-number-input>
                                }
                                @else if(getPriceType(editedPDRs[i].selectedPriceTypeDropdown) == PriceType.FIX)
                                {
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData"
                                    [inputId]="'material_costs_gas_fixed_actual_' + i" [inputType]="'number'"
                                    autoMarginTop="mt-0" [inputType]="'number'"
                                    [(inputValue)]="editedPDRs[i].material_costs_gas_fixed_actual"
                                    [warningMessage]="materialCostsGasFixedActualInputWarnings[i]"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: materialCostsGasFixedActualInputWarnings, pdrIndex: i})">
                                </app-custom-number-input>
                                }
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            @if(getPriceType(editedPDRs[i].selectedPriceTypeDropdown) == PriceType.VAR)
                            {
                            <app-delta-value
                                [calculationNumber]="pdr.calc_data?.material_costs_gas_variable_calc ?? null"
                                [extractionNumber]="pdr.material_costs_gas_variable_actual"></app-delta-value>
                            }
                            @else if(getPriceType(editedPDRs[i].selectedPriceTypeDropdown) == PriceType.FIX)
                            {
                            <app-delta-value [calculationNumber]="pdr.calc_data?.material_costs_gas_fixed_calc ?? null"
                                [extractionNumber]="pdr.material_costs_gas_fixed_actual"></app-delta-value>}
                        </td>
                    </tr>
                    @if(isMaterialCostsCollapsed)
                    {
                    <!-- Month Gas Consumption -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.1</p>
                                <p>{{ 'invoice.labels.month_gas_consumption' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPDRs[i].month_gas_consumption)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'month_gas_consumption_' + i"
                                    autoMarginTop="mt-0" [warningMessage]="monthGasConsumptionInputWarnings[i]"
                                    [(inputValue)]="editedPDRs[i].month_gas_consumption"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: monthGasConsumptionInputWarnings, pdrIndex: i})">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    @if(getPriceType(editedPDRs[i].selectedPriceTypeDropdown) == PriceType.VAR || viewAllComponents)
                    {
                    <!-- Variable gas consumption -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.2</p>
                                <p>{{ 'invoice.labels.variable_gas_consumption' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="editedPDRs[i].material_costs_gas_variable_actual === null || editedPDRs[i].material_costs_gas_variable_actual === undefined
                                    || editedPDRs[i].material_costs_gas_variable_actual === ''
                                    ? checkMandatoryVariableEmptyStatus(editedPDRs[i].variable_gas_consumption)
                                    : checkVariableEmptyStatus(editedPDRs[i].variable_gas_consumption)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'variable_gas_consumption_' + i"
                                    autoMarginTop="mt-0" [inputType]="'number'"
                                    [warningMessage]="variableGasConsumptionInputWarnings[i]"
                                    [(inputValue)]="editedPDRs[i].variable_gas_consumption"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: variableGasConsumptionInputWarnings, pdrIndex: i, fieldName: 'variable_gas_consumption'})">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>
                    }

                    @if(getPriceType(editedPDRs[i].selectedPriceTypeDropdown) == PriceType.FIX || viewAllComponents)
                    {
                    <!-- Fixed gas consumption -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.3</p>
                                <p>{{ 'invoice.labels.fixed_gas_consumption' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPDRs[i].fixed_gas_consumption)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'fixed_gas_consumption_' + i"
                                    autoMarginTop="mt-0" [inputType]="'number'"
                                    [warningMessage]="fixedGasConsumptionInputWarnings[i]"
                                    [(inputValue)]="editedPDRs[i].fixed_gas_consumption"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: fixedGasConsumptionInputWarnings, pdrIndex: i})">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>
                    }

                    <!-- HCV gas -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.4</p>
                                <p>{{ 'invoice.labels.hcv_gas' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPDRs[i].hcv_gas)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'hcv_gas_' + i" autoMarginTop="mt-0"
                                    [warningMessage]="hcvInputWarnings[i]" [(inputValue)]="editedPDRs[i].hcv_gas">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Material cost factor -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.5</p>
                                <p>{{ 'invoice.labels.material_cost_factor' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPDRs[i].material_cost_factor)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'material_cost_factor_' + i"
                                    autoMarginTop="mt-0" [warningMessage]="materialCostFactorInputWarnings[i]"
                                    [(inputValue)]="editedPDRs[i].material_cost_factor"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: materialCostFactorInputWarnings, pdrIndex: i})">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    @if(getPriceType(editedPDRs[i].selectedPriceTypeDropdown) == PriceType.FIX || viewAllComponents)
                    {
                    <!-- Price gas fix -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.6</p>
                                <p>{{ 'invoice.labels.price_gas_fix' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPDRs[i].price_gas_fix)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'price_gas_fix_' + i"
                                    autoMarginTop="mt-0" [inputType]="'number'"
                                    [(inputValue)]="editedPDRs[i].price_gas_fix" showCustomDecimals="1.2-6">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>
                    }


                    @if(getPriceType(editedPDRs[i].selectedPriceTypeDropdown) == PriceType.VAR || viewAllComponents)
                    {
                    <!-- Gas market price -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.7</p>
                                <p>{{ 'invoice.labels.gas_market_price' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="editedPDRs[i].material_costs_gas_variable_actual === null || editedPDRs[i].material_costs_gas_variable_actual === undefined
                                    || editedPDRs[i].material_costs_gas_variable_actual === ''
                                    ? checkMandatoryVariableEmptyStatus(editedPDRs[i].gas_market_price)
                                    : checkVariableEmptyStatus(editedPDRs[i].gas_market_price)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px] flex gap-1 items-center">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="true" [inputId]="'market_price_' + i" autoMarginTop="mt-0"
                                    [inputType]="'number'" [warningMessage]="gasMarketPriceInputWarnings[i]"
                                    [(inputValue)]="editedPDRs[i].gas_market_price"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: gasMarketPriceInputWarnings, pdrIndex: i, fieldName: 'gas_market_price'})">
                                </app-custom-number-input>

                                <div class="h-5 w-5 text-blue-700">
                                    <app-info-tooltip
                                        text="{{ 'admin.electricity_pun_gas_market_prices_info' | transloco }}"></app-info-tooltip>
                                </div>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Spread -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.8</p>
                                <p>{{ 'invoice.labels.spread' | transloco }}</p>
                                <app-invoice-variable-status [status]="editedPDRs[i].material_costs_gas_variable_actual === null || editedPDRs[i].material_costs_gas_variable_actual === undefined
                                    || editedPDRs[i].material_costs_gas_variable_actual === ''
                                    ? checkMandatoryVariableEmptyStatus(editedPDRs[i].spread)
                                    : checkVariableEmptyStatus(editedPDRs[i].spread)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'spread_' + i" autoMarginTop="mt-0"
                                    [warningMessage]="spreadInputWarnings[i]" [inputType]="'number'"
                                    [(inputValue)]="editedPDRs[i].spread"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: spreadInputWarnings, pdrIndex: i, fieldName: 'spread'})">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Price gas var calc -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">1.9</p>
                                <p>{{ 'invoice.labels.price_gas_var_actual' | transloco }}</p>
                                <app-invoice-variable-status [status]="editedPDRs[i].material_costs_gas_variable_actual === null || editedPDRs[i].material_costs_gas_variable_actual === undefined
                                    || editedPDRs[i].material_costs_gas_variable_actual === ''
                                    ? checkMandatoryVariableEmptyStatus(pdr?.calc_data?.price_gas_var_calc)
                                    : (pdr?.calc_data?.price_gas_var_calc === null || pdr?.calc_data?.price_gas_var_calc === undefined
                                        ?  checkVariableEmptyStatus(pdr?.calc_data?.price_gas_var_calc)
                                        : checkVariableEmptyStatus(editedPDRs[i].price_gas_var_actual))">
                                </app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pdr?.calc_data?.price_gas_var_calc)) {
                            {{ safeValue(pdr?.calc_data?.price_gas_var_calc) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'price_gas_var_actual_' + i"
                                    autoMarginTop="mt-0" [inputType]="'number'"
                                    [(inputValue)]="editedPDRs[i].price_gas_var_actual" showCustomDecimals="1.2-6">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                            <app-delta-value [calculationNumber]="pdr.calc_data?.price_gas_var_calc ?? null"
                                [extractionNumber]="pdr.price_gas_var_actual"></app-delta-value>
                        </td>
                    </tr>
                    }

                    }

                    <!-- TMS gas chages -->
                    <tr class="max-h-[50px] hover:bg-neutral-300 cursor-pointer"
                        (click)="isTMSGasCollapsed = !isTMSGasCollapsed">
                        <td class="border-b border-border px-4 py-4">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">2.</p>
                                <p>{{'shared.tms' | transloco}}</p>
                                <app-invoice-variable-status
                                    [status]="pdr?.calc_data?.tms_gas_charges_calc === null || pdr?.calc_data?.tms_gas_charges_calc === undefined
                                    ? checkMandatoryVariableEmptyStatus(pdr?.calc_data?.tms_gas_charges_calc)
                                    : checkMandatoryVariableEmptyStatus(editedPDRs[i].tms_gas_charges_actual)"></app-invoice-variable-status>
                                <app-collapse-arrow [isOpen]="isTMSGasCollapsed"></app-collapse-arrow>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pdr?.calc_data?.tms_gas_charges_calc)) {
                            {{ safeValue(pdr?.calc_data?.tms_gas_charges_calc) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'tms' + i" [inputType]="'number'"
                                    autoMarginTop="mt-0" [inputType]="'number'"
                                    [warningMessage]="tmsGasChargesActualInputWarnings[i]"
                                    [(inputValue)]="editedPDRs[i].tms_gas_charges_actual"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: tmsGasChargesActualInputWarnings, pdrIndex: i})">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <app-delta-value [calculationNumber]="pdr.calc_data?.tms_gas_charges_calc ?? null"
                                [extractionNumber]="pdr.tms_gas_charges_actual"></app-delta-value>
                        </td>
                    </tr>
                    @if(isTMSGasCollapsed)
                    {
                    <!-- Fixed distribution costs gas calc-->
                    <tr class="max-h-[50px] bg-blue-100">
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">2.1</p>
                                <p>{{'invoice.labels.fixed_distribution_costs_gas_actual' | transloco}}</p>
                                <app-invoice-variable-status
                                    [status]="pdr.fixed_distribution_costs_gas_calc === null || pdr.fixed_distribution_costs_gas_calc === undefined
                                    ? checkMandatoryVariableEmptyStatus(pdr.fixed_distribution_costs_gas_calc)
                                    : checkVariableEmptyStatus(editedPDRs[i].fixed_distribution_costs_gas_actual)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pdr.fixed_distribution_costs_gas_calc)) {
                            {{ safeValue(pdr.fixed_distribution_costs_gas_calc) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData"
                                    [inputId]="'fixed_distribution_costs_gas_actual_' + i" [inputType]="'number'"
                                    autoMarginTop="mt-0" [inputType]="'number'"
                                    [(inputValue)]="editedPDRs[i].fixed_distribution_costs_gas_actual">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <app-delta-value [calculationNumber]="pdr.fixed_distribution_costs_gas_calc ?? null"
                                [extractionNumber]="pdr.fixed_distribution_costs_gas_actual"></app-delta-value>
                        </td>
                    </tr>

                    <!-- Var transportation cost -->
                    <tr class="max-h-[50px] bg-blue-100 cursor-pointer hover:bg-blue-200"
                        (click)="isVariableTransportationCostsCollapsed=!isVariableTransportationCostsCollapsed">
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">2.2</p>
                                <p>{{'invoice.labels.var_transportation_costs_actual' | transloco}}</p>
                                <app-invoice-variable-status
                                    [status]="pdr?.calc_data?.var_transportation_costs_calc === null || pdr?.calc_data?.var_transportation_costs_calc === undefined
                                    ? checkMandatoryVariableEmptyStatus(pdr?.calc_data?.var_transportation_costs_calc)
                                    : checkVariableEmptyStatus(editedPDRs[i].var_transportation_costs_actual)"></app-invoice-variable-status>
                                <app-collapse-arrow
                                    [isOpen]="isVariableTransportationCostsCollapsed"></app-collapse-arrow>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pdr?.calc_data?.var_transportation_costs_calc)) {
                            {{ safeValue(pdr?.calc_data?.var_transportation_costs_calc) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData"
                                    [inputId]="'var_transportation_costs_actual_' + i" [inputType]="'number'"
                                    autoMarginTop="mt-0" [inputType]="'number'"
                                    [(inputValue)]="editedPDRs[i].var_transportation_costs_actual">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <app-delta-value [calculationNumber]="pdr.calc_data?.var_transportation_costs_calc ?? null"
                                [extractionNumber]="pdr.var_transportation_costs_actual"></app-delta-value>
                        </td>
                    </tr>

                    @if(isVariableTransportationCostsCollapsed)
                    {
                    <!-- Variable transportation fee -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-8">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">2.2.1</p>
                                <p>{{ 'invoice.labels.variable_transportation_fee' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPDRs[i].variable_transportation_fee)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'variable_transportation_fee_' + i"
                                    autoMarginTop="mt-0" [inputType]="'number'"
                                    [warningMessage]="variableTransportationFeeInputWarnings[i]"
                                    [(inputValue)]="editedPDRs[i].variable_transportation_fee"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: variableTransportationFeeInputWarnings, pdrIndex: i})">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Month Gas Consumption -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-8">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">2.2.2</p>
                                <p>{{ 'invoice.labels.month_gas_consumption' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPDRs[i].month_gas_consumption)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'month_gas_consumption_' + i"
                                    autoMarginTop="mt-0" [warningMessage]="monthGasConsumptionInputWarnings[i]"
                                    [(inputValue)]="editedPDRs[i].month_gas_consumption"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: monthGasConsumptionInputWarnings, pdrIndex: i})">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>
                    }


                    <!-- Total var distribution costs calc -->
                    <tr class="max-h-[50px] bg-blue-100 cursor-pointer hover:bg-blue-200"
                        (click)="isTotalVariableDistributionCostsCollapsed=!isTotalVariableDistributionCostsCollapsed">
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">2.3</p>
                                <p>{{'invoice.labels.total_var_distribution_costs_actual' | transloco}}</p>
                                <app-invoice-variable-status
                                    [status]="pdr?.calc_data?.total_var_distribution_costs_calc === null || pdr?.calc_data?.total_var_distribution_costs_calc === undefined
                                    ? checkMandatoryVariableEmptyStatus(pdr?.calc_data?.total_var_distribution_costs_calc)
                                    : checkVariableEmptyStatus(editedPDRs[i].total_var_distribution_costs_actual)"></app-invoice-variable-status>
                                <app-collapse-arrow
                                    [isOpen]="isTotalVariableDistributionCostsCollapsed"></app-collapse-arrow>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pdr?.calc_data?.total_var_distribution_costs_calc)) {
                            {{ safeValue(pdr?.calc_data?.total_var_distribution_costs_calc) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData"
                                    [inputId]="'total_var_distribution_costs_actual_' + i" [inputType]="'number'"
                                    autoMarginTop="mt-0" [inputType]="'number'"
                                    [(inputValue)]="editedPDRs[i].total_var_distribution_costs_actual">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <app-delta-value
                                [calculationNumber]="pdr.calc_data?.total_var_distribution_costs_calc ?? null"
                                [extractionNumber]="pdr.total_var_distribution_costs_actual"></app-delta-value>
                        </td>
                    </tr>

                    @if(isTotalVariableDistributionCostsCollapsed)
                    {
                    <!-- Var distribution costs tier1 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-8">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">2.3.1</p>
                                <p>{{ 'invoice.labels.var_distribution_costs_tier' | transloco }} 1</p>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pdr?.calc_data?.var_distribution_costs_tier1)) {
                            {{ safeValue(pdr?.calc_data?.var_distribution_costs_tier1) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Var distribution costs tier2 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-8">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">2.3.2</p>
                                <p>{{ 'invoice.labels.var_distribution_costs_tier' | transloco }} 2</p>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pdr?.calc_data?.var_distribution_costs_tier2)) {
                            {{ safeValue(pdr?.calc_data?.var_distribution_costs_tier2) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Var distribution costs tier3 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-8">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">2.3.3</p>
                                <p>{{ 'invoice.labels.var_distribution_costs_tier' | transloco }} 3</p>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pdr?.calc_data?.var_distribution_costs_tier3)) {
                            {{ safeValue(pdr?.calc_data?.var_distribution_costs_tier3) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Var distribution costs tier4 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-8">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">2.3.4</p>
                                <p>{{ 'invoice.labels.var_distribution_costs_tier' | transloco }} 4</p>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pdr?.calc_data?.var_distribution_costs_tier4)) {
                            {{ safeValue(pdr?.calc_data?.var_distribution_costs_tier4) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Var distribution costs tier5 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-8">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">2.3.5</p>
                                <p>{{ 'invoice.labels.var_distribution_costs_tier' | transloco }} 5</p>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pdr?.calc_data?.var_distribution_costs_tier5)) {
                            {{ safeValue(pdr?.calc_data?.var_distribution_costs_tier5) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Var distribution costs tier6 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-8">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">2.3.6</p>
                                <p>{{ 'invoice.labels.var_distribution_costs_tier' | transloco }} 6</p>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pdr?.calc_data?.var_distribution_costs_tier6)) {
                            {{ safeValue(pdr?.calc_data?.var_distribution_costs_tier6) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Var distribution costs tier7 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-8">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">2.3.7</p>
                                <p>{{ 'invoice.labels.var_distribution_costs_tier' | transloco }} 7</p>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pdr?.calc_data?.var_distribution_costs_tier7)) {
                            {{ safeValue(pdr?.calc_data?.var_distribution_costs_tier7) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Var distribution costs tier8 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-8">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">2.3.8</p>
                                <p>{{ 'invoice.labels.var_distribution_costs_tier' | transloco }} 8</p>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pdr?.calc_data?.var_distribution_costs_tier8)) {
                            {{ safeValue(pdr?.calc_data?.var_distribution_costs_tier8) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Cummulated gas consumption -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-8">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">2.3.9</p>
                                <p>{{ 'invoice.labels.cummulated_gas_consumption' | transloco }}</p>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pdr?.calc_data?.cummulated_gas_consumption)) {
                            {{ safeValue(pdr?.calc_data?.cummulated_gas_consumption) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Var distribution fee tier1 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-8">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">2.3.10</p>
                                <p>{{ 'invoice.labels.var_distribution_fee_tier' | transloco }} 1</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPDRs[i].var_distribution_fee_tier1)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'variable_transportation_fee' + i"
                                    autoMarginTop="mt-0" [inputType]="'number'"
                                    [warningMessage]="varDistributionFeeTier1InputWarnings[i]"
                                    [(inputValue)]="editedPDRs[i].var_distribution_fee_tier1"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: varDistributionFeeTier1InputWarnings, pdrIndex: i})">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Var distribution fee tier2 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-8">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">2.3.11</p>
                                <p>{{ 'invoice.labels.var_distribution_fee_tier' | transloco }} 2</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPDRs[i].var_distribution_fee_tier2)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'variable_transportation_fee' + i"
                                    autoMarginTop="mt-0" [inputType]="'number'"
                                    [warningMessage]="varDistributionFeeTier2InputWarnings[i]"
                                    [(inputValue)]="editedPDRs[i].var_distribution_fee_tier2"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: varDistributionFeeTier2InputWarnings, pdrIndex: i})">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Var distribution fee tier3 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-8">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">2.3.12</p>
                                <p>{{ 'invoice.labels.var_distribution_fee_tier' | transloco }} 3</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPDRs[i].var_distribution_fee_tier3)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'variable_transportation_fee' + i"
                                    autoMarginTop="mt-0" [inputType]="'number'"
                                    [warningMessage]="varDistributionFeeTier3InputWarnings[i]"
                                    [(inputValue)]="editedPDRs[i].var_distribution_fee_tier3"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: varDistributionFeeTier3InputWarnings, pdrIndex: i})">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Var distribution fee tier4 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-8">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">2.3.13</p>
                                <p>{{ 'invoice.labels.var_distribution_fee_tier' | transloco }} 4</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPDRs[i].var_distribution_fee_tier4)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'variable_transportation_fee' + i"
                                    autoMarginTop="mt-0" [inputType]="'number'"
                                    [warningMessage]="varDistributionFeeTier4InputWarnings[i]"
                                    [(inputValue)]="editedPDRs[i].var_distribution_fee_tier4"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: varDistributionFeeTier4InputWarnings, pdrIndex: i})">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Var distribution fee tier5 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-8">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">2.3.14</p>
                                <p>{{ 'invoice.labels.var_distribution_fee_tier' | transloco }} 5</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPDRs[i].var_distribution_fee_tier5)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'variable_transportation_fee' + i"
                                    autoMarginTop="mt-0" [inputType]="'number'"
                                    [warningMessage]="varDistributionFeeTier5InputWarnings[i]"
                                    [(inputValue)]="editedPDRs[i].var_distribution_fee_tier5"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: varDistributionFeeTier5InputWarnings, pdrIndex: i})">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Var distribution fee tier6 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-8">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">2.3.15</p>
                                <p>{{ 'invoice.labels.var_distribution_fee_tier' | transloco }} 6</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPDRs[i].var_distribution_fee_tier6)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'variable_transportation_fee' + i"
                                    autoMarginTop="mt-0" [inputType]="'number'"
                                    [warningMessage]="varDistributionFeeTier6InputWarnings[i]"
                                    [(inputValue)]="editedPDRs[i].var_distribution_fee_tier6"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: varDistributionFeeTier6InputWarnings, pdrIndex: i})">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Var distribution fee tier7 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-8">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">2.3.16</p>
                                <p>{{ 'invoice.labels.var_distribution_fee_tier' | transloco }} 7</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPDRs[i].var_distribution_fee_tier7)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'variable_transportation_fee' + i"
                                    autoMarginTop="mt-0" [inputType]="'number'"
                                    [warningMessage]="varDistributionFeeTier7InputWarnings[i]"
                                    [(inputValue)]="editedPDRs[i].var_distribution_fee_tier7"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: varDistributionFeeTier7InputWarnings, pdrIndex: i})">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Var distribution fee tier8 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-8">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">2.3.17</p>
                                <p>{{ 'invoice.labels.var_distribution_fee_tier' | transloco }} 8</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPDRs[i].var_distribution_fee_tier8)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'variable_transportation_fee' + i"
                                    autoMarginTop="mt-0" [inputType]="'number'"
                                    [warningMessage]="varDistributionFeeTier8InputWarnings[i]"
                                    [(inputValue)]="editedPDRs[i].var_distribution_fee_tier8"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: varDistributionFeeTier8InputWarnings, pdrIndex: i})">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Consumption tier1 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-8">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">2.3.18</p>
                                <p>{{ 'invoice.labels.consumption_tier' | transloco }} 1</p>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pdr?.calc_data?.consumption_tier_1)) {
                            {{ safeValue(pdr?.calc_data?.consumption_tier_1) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Consumption tier2 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-8">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">2.3.19</p>
                                <p>{{ 'invoice.labels.consumption_tier' | transloco }} 2</p>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pdr?.calc_data?.consumption_tier_2)) {
                            {{ safeValue(pdr?.calc_data?.consumption_tier_2) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Consumption tier3 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-8">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">2.3.20</p>
                                <p>{{ 'invoice.labels.consumption_tier' | transloco }} 3</p>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pdr?.calc_data?.consumption_tier_3)) {
                            {{ safeValue(pdr?.calc_data?.consumption_tier_3) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Consumption tier4 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-8">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">2.3.21</p>
                                <p>{{ 'invoice.labels.consumption_tier' | transloco }} 4</p>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pdr?.calc_data?.consumption_tier_4)) {
                            {{ safeValue(pdr?.calc_data?.consumption_tier_4) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Consumption tier5 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-8">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">2.3.22</p>
                                <p>{{ 'invoice.labels.consumption_tier' | transloco }} 5</p>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pdr?.calc_data?.consumption_tier_5)) {
                            {{ safeValue(pdr?.calc_data?.consumption_tier_5) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Consumption tier6 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-8">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">2.3.23</p>
                                <p>{{ 'invoice.labels.consumption_tier' | transloco }} 6</p>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pdr?.calc_data?.consumption_tier_6)) {
                            {{ safeValue(pdr?.calc_data?.consumption_tier_6) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Consumption tier7 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-8">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">2.3.24</p>
                                <p>{{ 'invoice.labels.consumption_tier' | transloco }} 7</p>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pdr?.calc_data?.consumption_tier_7)) {
                            {{ safeValue(pdr?.calc_data?.consumption_tier_7) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Consumption tier8 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-8">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">2.3.25</p>
                                <p>{{ 'invoice.labels.consumption_tier' | transloco }} 8</p>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pdr?.calc_data?.consumption_tier_8)) {
                            {{ safeValue(pdr?.calc_data?.consumption_tier_8) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>
                    }
                    }

                    <!-- Total gas taxes -->
                    <tr class="max-h-[50px] hover:bg-neutral-300 cursor-pointer"
                        (click)="isTaxesCollapsed = !isTaxesCollapsed">
                        <td class="border-b border-border px-4 py-4">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">3.</p>
                                <p>{{'invoice.labels.total_gas_taxes_actual' | transloco}}</p>
                                <app-invoice-variable-status
                                    [status]="pdr?.calc_data?.total_gas_taxes_calc === null || pdr?.calc_data?.total_gas_taxes_calc === undefined
                                    ? checkMandatoryVariableEmptyStatus(pdr?.calc_data?.total_gas_taxes_calc)
                                    : checkMandatoryVariableEmptyStatus(editedPDRs[i].total_gas_taxes_actual)"></app-invoice-variable-status>
                                <app-collapse-arrow [isOpen]="isTaxesCollapsed"></app-collapse-arrow>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pdr?.calc_data?.total_gas_taxes_calc)) {
                            {{ safeValue(pdr?.calc_data?.total_gas_taxes_calc) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'total_gas_taxes_actual_' + i"
                                    [inputType]="'number'" autoMarginTop="mt-0" [inputType]="'number'"
                                    [warningMessage]="totalGasTaxesActualInputWarnings[i]"
                                    [(inputValue)]="editedPDRs[i].total_gas_taxes_actual"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: totalGasTaxesActualInputWarnings, pdrIndex: i})">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <app-delta-value [calculationNumber]="pdr.calc_data?.total_gas_taxes_calc ?? null"
                                [extractionNumber]="pdr.total_gas_taxes_actual"></app-delta-value>
                        </td>
                    </tr>
                    @if(isTaxesCollapsed)
                    {
                    <!-- Exercise Tax Type -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">3.1</p>
                                <p>{{ 'invoice.labels.exercise_tax_type_gas' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPDRs[i].exercise_tax_type_gas)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4 flex gap-1 items-center">
                            @if (safeStringValue(pdr?.expected_exercise_tax_type_gas)) {
                            {{ safeStringValue(pdr?.expected_exercise_tax_type_gas) }}
                            }@else if (safeStringValue(pdr?.exercise_tax_type_gas)) {
                            <span class="text-error" title="{{ 'admin.fallback_value_used' | transloco }}">{{
                                safeStringValue(pdr?.exercise_tax_type_gas) }}</span>
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }

                            <div class="h-5 w-5 text-blue-700">
                                <app-info-tooltip
                                    text="{{ 'admin.expected_exercise_tax_type_info' | transloco }}"></app-info-tooltip>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Tax Type -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">3.2</p>
                                <p>{{ 'invoice.labels.tax_type_gas' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPDRs[i].tax_type_gas)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-labeled-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'tax_type_gas' + i"
                                    [inputType]="'text'" [(inputValue)]="editedPDRs[i].tax_type_gas"
                                    [warningMessage]="taxTypeGasInputWarnings[i]"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: taxTypeGasInputWarnings, pdrIndex: i})">
                                </app-labeled-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Cummulated gas consumption -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">3.3</p>
                                <p>{{ 'invoice.labels.cummulated_gas_consumption' | transloco }}</p>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pdr?.calc_data?.cummulated_gas_consumption)) {
                            {{ safeValue(pdr?.calc_data?.cummulated_gas_consumption) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>


                    <!-- Tax Consumption scale1 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">3.4</p>
                                <p>{{ 'invoice.labels.tax_consumption_scale' | transloco }} 1</p>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pdr?.calc_data?.tax_consumption_scale1)) {
                            {{ safeValue(pdr?.calc_data?.tax_consumption_scale1) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Tax Consumption scale2 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">3.5</p>
                                <p>{{ 'invoice.labels.tax_consumption_scale' | transloco }} 2</p>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pdr?.calc_data?.tax_consumption_scale2)) {
                            {{ safeValue(pdr?.calc_data?.tax_consumption_scale2) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Tax Consumption scale3 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">3.6</p>
                                <p>{{ 'invoice.labels.tax_consumption_scale' | transloco }} 3</p>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pdr?.calc_data?.tax_consumption_scale3)) {
                            {{ safeValue(pdr?.calc_data?.tax_consumption_scale3) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Tax Consumption scale4 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">3.7</p>
                                <p>{{ 'invoice.labels.tax_consumption_scale' | transloco }} 4</p>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pdr?.calc_data?.tax_consumption_scale4)) {
                            {{ safeValue(pdr?.calc_data?.tax_consumption_scale4) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Taxrate gas scale1 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">3.8</p>
                                <p>{{ 'invoice.labels.taxrate_gas_scale1' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPDRs[i].taxrate_gas_scale1)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'tax1_' + i" autoMarginTop="mt-0"
                                    [inputType]="'number'" [warningMessage]="taxRateGasScale1InputWarnings[i]"
                                    [(inputValue)]="editedPDRs[i].taxrate_gas_scale1"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: taxRateGasScale1InputWarnings, pdrIndex: i})">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Taxrate gas scale2 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">3.9</p>
                                <p>{{ 'invoice.labels.taxrate_gas_scale2' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPDRs[i].taxrate_gas_scale2)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'tax2_' + i" autoMarginTop="mt-0"
                                    [inputType]="'number'" [warningMessage]="taxRateGasScale2InputWarnings[i]"
                                    [(inputValue)]="editedPDRs[i].taxrate_gas_scale2"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: taxRateGasScale2InputWarnings, pdrIndex: i})">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Taxrate gas scale3 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">3.10</p>
                                <p>{{ 'invoice.labels.taxrate_gas_scale3' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPDRs[i].taxrate_gas_scale3)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'tax3_' + i" autoMarginTop="mt-0"
                                    [inputType]="'number'" [warningMessage]="taxRateGasScale3InputWarnings[i]"
                                    [(inputValue)]="editedPDRs[i].taxrate_gas_scale3"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: taxRateGasScale3InputWarnings, pdrIndex: i})">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Taxrate gas scale4 -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">3.11</p>
                                <p>{{ 'invoice.labels.taxrate_gas_scale4' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPDRs[i].taxrate_gas_scale4)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'tax4_' + i" autoMarginTop="mt-0"
                                    [inputType]="'number'" [warningMessage]="taxRateGasScale4InputWarnings[i]"
                                    [(inputValue)]="editedPDRs[i].taxrate_gas_scale4"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: taxRateGasScale4InputWarnings, pdrIndex: i})">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>
                    }


                    <!-- Invoice Charges -->
                    <tr class="max-h-[50px] hover:bg-neutral-300 cursor-pointer"
                        (click)="isInvoiceChargesCollapsed = !isInvoiceChargesCollapsed">
                        <td class="border-b border-border px-4 py-4">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">4.</p>
                                <p>{{'admin.invoice_charges' | transloco}}</p>
                                <app-collapse-arrow [isOpen]="isInvoiceChargesCollapsed"></app-collapse-arrow>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            <!-- Additional Note-->
                            <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                [isDisabled]="!isEditingInvoiceData" [inputId]="'invoice_charges_note' + i"
                                autoMarginTop="mt-0" [inputType]="'number'" bgColor="bg-purple-100"
                                title="{{ 'admin.additional_note' | transloco }}"
                                [(inputValue)]="editedPDRs[i].additionalNoteFields.invoice_charges"
                                [allowCalculator]="true"
                                (trackCalcExprHistoryChange)="onExprChange('invoice_charges', i, $event)">
                            </app-custom-number-input>
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    @if(isInvoiceChargesCollapsed)
                    {
                    <!-- fixed charge gas calc-->
                    <tr class="max-h-[50px] bg-blue-100 hover:bg-blue-200 cursor-pointer"
                        (click)="isFixedCostsCollapsed=!isFixedCostsCollapsed">
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">4.1</p>
                                <p>{{'invoice.labels.fixed_charge_gas_actual' | transloco}}</p>
                                <app-invoice-variable-status
                                    [status]="pdr?.calc_data?.fixed_charge_gas_calc === null || pdr?.calc_data?.fixed_charge_gas_calc === undefined
                                    ? checkVariableEmptyStatus(pdr?.calc_data?.fixed_charge_gas_calc)
                                    : checkVariableEmptyStatus(editedPDRs[i].fixed_charge_gas_actual)"></app-invoice-variable-status>
                                <app-collapse-arrow [isOpen]="isFixedCostsCollapsed"></app-collapse-arrow>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pdr?.calc_data?.fixed_charge_gas_calc)) {
                            {{ safeValue(pdr?.calc_data?.fixed_charge_gas_calc) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'fixed_charge_gas_actual_' + i"
                                    [inputType]="'number'" autoMarginTop="mt-0" [inputType]="'number'"
                                    [(inputValue)]="editedPDRs[i].fixed_charge_gas_actual">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <app-delta-value [calculationNumber]="pdr?.calc_data?.fixed_charge_gas_calc ?? null"
                                [extractionNumber]="pdr.fixed_charge_gas_actual"></app-delta-value>
                        </td>
                    </tr>
                    @if(isFixedCostsCollapsed)
                    {
                    <!-- Daily capacity factor gas -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-8">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">4.1.1</p>
                                <p>{{ 'invoice.labels.daily_capacity_factor_gas' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkVariableEmptyStatus(editedPDRs[i].daily_capacity_factor_gas)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                [isDisabled]="!isEditingInvoiceData" [inputId]="'daily_capacity_factor_gas_' + i"
                                autoMarginTop="mt-0" [(inputValue)]="editedPDRs[i].daily_capacity_factor_gas">
                            </app-custom-number-input>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Month Gas Consumption -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-8">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">4.1.2</p>
                                <p>{{ 'invoice.labels.month_gas_consumption' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkMandatoryVariableEmptyStatus(editedPDRs[i].month_gas_consumption)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'month_gas_consumption_' + i"
                                    autoMarginTop="mt-0" [warningMessage]="monthGasConsumptionInputWarnings[i]"
                                    [(inputValue)]="editedPDRs[i].month_gas_consumption"
                                    (inputValueLength)="onFieldChange({ value: $event, targetArray: monthGasConsumptionInputWarnings, pdrIndex: i})">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>
                    }

                    <!-- Fixed quota -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">4.2</p>
                                <p>{{'invoice.labels.fixed_quota' | transloco}}</p>
                                <app-invoice-variable-status
                                    [status]="checkVariableEmptyStatus(editedPDRs[i].fixed_quota)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'fixed_quota' + i"
                                    [inputType]="'number'" autoMarginTop="mt-0" [inputType]="'number'"
                                    [(inputValue)]="editedPDRs[i].fixed_quota">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Additional charges -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">4.3</p>
                                <p>{{'invoice.labels.additional_gas_charges' | transloco}}</p>
                                <app-invoice-variable-status
                                    [status]="checkVariableEmptyStatus(editedPDRs[i].additional_gas_charges)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'additional_gas_charges_' + i"
                                    [inputType]="'number'" autoMarginTop="mt-0" [inputType]="'number'"
                                    [(inputValue)]="editedPDRs[i].additional_gas_charges">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Total discount amount -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">4.4</p>
                                <p>{{'invoice.labels.total_gas_discount_amount' | transloco}}</p>
                                <app-invoice-variable-status
                                    [status]="checkVariableEmptyStatus(editedPDRs[i].total_gas_discount_amount)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'total_gas_discount_amount_' + i"
                                    [inputType]="'number'" autoMarginTop="mt-0" [inputType]="'number'"
                                    [(inputValue)]="editedPDRs[i].total_gas_discount_amount">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Invoice nontaxable amount -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">4.5</p>
                                <p>{{ 'invoice.labels.nontaxable_amount' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkVariableEmptyStatus(nontaxableAmountInput)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'nontaxableAmount'"
                                    autoMarginTop="mt-0" [inputType]="'number'" [(inputValue)]="nontaxableAmountInput"
                                    [errorMessage]="nontaxableAmountInputError">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>
                    }

                    <!-- Invoice amount net -->
                    <tr class="max-h-[50px]">
                        <td class="border-b border-border px-4 py-4">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">5.</p>
                                <p>{{'invoice.labels.amount_actual' | transloco}}</p>
                                <app-invoice-variable-status
                                    [status]="pdr?.calc_data?.invoice_amount_net_calc === null || pdr?.calc_data?.invoice_amount_net_calc === undefined
                                    ? checkMandatoryVariableEmptyStatus(pdr?.calc_data?.invoice_amount_net_calc)
                                    : checkMandatoryVariableEmptyStatus(invoiceAmountActualInput)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pdr?.calc_data?.invoice_amount_net_calc)) {
                            {{ safeValue(pdr?.calc_data?.invoice_amount_net_calc) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'invoiceAmountActual'"
                                    autoMarginTop="mt-0" [inputType]="'number'"
                                    [(inputValue)]="invoiceAmountActualInput"
                                    [errorMessage]="invoiceAmountActualInputError"
                                    [warningMessage]="invoiceAmountActualInputWarning"
                                    placeholder="{{ 'invoice.placeholders.amount' | transloco }}"
                                    (inputValueLength)="onFieldChange({ value: $event, fieldName: 'invoiceAmountActual' })">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <app-delta-value [calculationNumber]="pdr.calc_data?.invoice_amount_net_calc ?? null"
                                [extractionNumber]="invoice?.invoice_amount_net_actual ?? null"></app-delta-value>
                        </td>
                    </tr>

                    <!-- Vat amount -->
                    <tr class="max-h-[50px] hover:bg-neutral-300 cursor-pointer"
                        (click)="isVATCollapsed = !isVATCollapsed">
                        <td class="border-b border-border px-4 py-4">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">6.</p>
                                <p>{{'invoice.labels.vat_amount' | transloco}}</p>
                                <app-invoice-variable-status
                                    [status]="pdr?.calc_data?.vat_amount_calc === null || pdr?.calc_data?.vat_amount_calc === undefined
                                    ? checkMandatoryVariableEmptyStatus(pdr?.calc_data?.vat_amount_calc)
                                    : checkVariableEmptyStatus(editedPDRs[i].vat_amount_actual)"></app-invoice-variable-status>
                                <app-collapse-arrow [isOpen]="isVATCollapsed"></app-collapse-arrow>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pdr?.calc_data?.vat_amount_calc)) {
                            {{ safeValue(pdr?.calc_data?.vat_amount_calc) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <div class="min-w-[250px]">
                                    <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                        [isDisabled]="!isEditingInvoiceData" [inputId]="'vat_amount_actual' + i"
                                        autoMarginTop="mt-0" [inputType]="'number'"
                                        [(inputValue)]="editedPDRs[i].vat_amount_actual">
                                    </app-custom-number-input>
                                </div>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <app-delta-value [calculationNumber]="pdr.calc_data?.vat_amount_calc ?? null"
                                [extractionNumber]="pdr.vat_amount_actual"></app-delta-value>
                        </td>
                    </tr>

                    @if(isVATCollapsed)
                    {
                    <!-- Invoice VAT Rate -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">6.1</p>
                                <p>{{ 'invoice.labels.vat_rate' | transloco }}</p>
                                <app-invoice-variable-status
                                    [status]="checkVariableEmptyStatus(editedPDRs[i].vat_rate)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(invoice?.expected_vat_rate)) {
                            {{ safeValue(invoice?.expected_vat_rate) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'vat_rate' + i" autoMarginTop="mt-0"
                                    placeholder="{{ 'invoice.placeholders.enter_as_decimal' | transloco }}"
                                    [inputType]="'text'" [(inputValue)]="editedPDRs[i].vat_rate">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                            <app-delta-value [calculationNumber]="invoice?.expected_vat_rate ?? null"
                                [extractionNumber]="pdr.vat_rate"></app-delta-value>
                        </td>
                    </tr>
                    }

                    <!-- Invoice amount gross -->
                    <tr class="max-h-[50px]">
                        <td class="border-b border-border px-4 py-4">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">7.</p>
                                <p>{{'invoice.labels.amount_gross' | transloco}}</p>
                                <app-invoice-variable-status [status]="pdr?.calc_data?.invoice_amount_gross_calc === null || pdr?.calc_data?.invoice_amount_gross_calc === undefined
                                    ? checkMandatoryVariableEmptyStatus(pdr?.calc_data?.invoice_amount_gross_calc)
                                    : checkVariableEmptyStatus(invoiceAmountGrossInput)"></app-invoice-variable-status>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            @if (safeValue(pdr?.calc_data?.invoice_amount_gross_calc)) {
                            {{ safeValue(pdr?.calc_data?.invoice_amount_gross_calc) }}
                            } @else if (isAnyMandatoryVariableMissing()) {
                            <app-mandatory-data-missing
                                (onClick)="handleMissingDataClick()"></app-mandatory-data-missing>
                            }
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-number-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'invoiceAmountGross'"
                                    autoMarginTop="mt-0" [inputType]="'number'" [(inputValue)]="invoiceAmountGrossInput"
                                    [errorMessage]="invoiceAmountGrossInputError"
                                    placeholder="{{ 'invoice.placeholders.amount' | transloco }}">
                                </app-custom-number-input>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <app-delta-value [calculationNumber]="pdr.calc_data?.invoice_amount_gross_calc ?? null"
                                [extractionNumber]="invoice?.invoice_amount_gross_actual ?? null"></app-delta-value>
                        </td>
                    </tr>

                    <!-- Supplier -->
                    <tr class="max-h-[50px] hover:bg-neutral-300 cursor-pointer"
                        (click)="isSupplierCollapsed = !isSupplierCollapsed">
                        <td class="border-b border-border px-4 py-4">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">8.</p>
                                <p>{{'invoice.sections.supplier_details' | transloco}}</p>
                                <app-collapse-arrow [isOpen]="isSupplierCollapsed"></app-collapse-arrow>
                            </div>
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <td class="border-b border-border px-4 py-4">
                            <p>{{ editedPDRs[i].supplierData.name || '' }}</p>
                        </td>
                        <td class="border-b border-border px-4 py-4">

                        </td>
                    </tr>
                    @if(isSupplierCollapsed)
                    {
                    <!-- Supplier Name -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">11.1</p>
                                <p>{{ 'invoice.labels.supplier_name' | transloco }}</p>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-labeled-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'supplier_name_' + i"
                                    autoMarginTop="mt-0" [inputType]="'text'"
                                    [(inputValue)]="editedPDRs[i].supplierData.name">
                                </app-labeled-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>
                    <!-- Supplier VAT ID -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">11.2</p>
                                <p>{{ 'invoice.labels.vat_id' | transloco }}</p>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-labeled-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'vat_id_' + i" [inputType]="'text'"
                                    autoMarginTop="mt-0" [(inputValue)]="editedPDRs[i].supplierData.vat_id">
                                </app-labeled-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Supplier Contact Name -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">11.3</p>
                                <p>{{ 'invoice.labels.contact_name' | transloco }}</p>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-labeled-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'contact_name_' + i"
                                    autoMarginTop="mt-0" [inputType]="'text'"
                                    [(inputValue)]="editedPDRs[i].supplierData.contact_name">
                                </app-labeled-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Supplier Contact Number -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">11.4</p>
                                <p>{{ 'invoice.labels.contact_number' | transloco }}</p>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-labeled-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    [isDisabled]="!isEditingInvoiceData" [inputId]="'contact_number_' + i"
                                    autoMarginTop="mt-0" [inputType]="'text'"
                                    [(inputValue)]="editedPDRs[i].supplierData.contact_number">
                                </app-labeled-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Supplier Email -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">11.5</p>
                                <p>{{ 'invoice.labels.email' | transloco }}</p>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-labeled-input boxHeight="h-[40px]" [showOnlyValueWhenDisabled]="true"
                                    autoMarginTop="mt-0" [isDisabled]="!isEditingInvoiceData" [inputId]="'email_' + i"
                                    [inputType]="'text'" [(inputValue)]="editedPDRs[i].supplierData.email">
                                </app-labeled-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Supplier Start of Supply -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">11.6</p>
                                <p>{{ 'shared.labels.gas.start_of_supply' | transloco }}</p>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-date-input inputId="'supplier_start_of_supply_' + i"
                                    placeholder="{{ 'shared.placeholders.gas.start_of_supply' | transloco }}"
                                    [(dateValue)]="editedPDRs[i].supplierData.start_of_supply" [errorMessage]="null"
                                    [isDisabled]="!isEditingInvoiceData" [showOnlyValueWhenDisabled]="true"
                                    autoMarginTop="mt-0" dateFormat="dd/mm/yy" boxHeight="h-[40px]">
                                </app-custom-date-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>

                    <!-- Supplier End of Supply -->
                    <tr class="max-h-[50px] bg-blue-100">
                        <!-- Component name -->
                        <td class="border-b border-border px-4 py-4 pl-6">
                            <div class="flex gap-2">
                                <p class="text-neutral-500">11.7</p>
                                <p>{{ 'shared.labels.gas.end_of_supply' | transloco }}</p>
                            </div>
                        </td>
                        <!-- Calculation -->
                        <td class="border-b border-border px-4 py-4">
                            -
                        </td>
                        <!-- Extraction -->
                        <td class="border-b border-border px-4 py-4">
                            <div class="min-w-[250px]">
                                <app-custom-date-input inputId="'supplier_end_of_supply_' + i"
                                    placeholder="{{ 'shared.placeholders.gas.end_of_supply' | transloco }}"
                                    [(dateValue)]="editedPDRs[i].supplierData.end_of_supply" [errorMessage]="null"
                                    [isDisabled]="!isEditingInvoiceData" [showOnlyValueWhenDisabled]="true"
                                    autoMarginTop="mt-0" dateFormat="dd/mm/yy" boxHeight="h-[40px]">
                                </app-custom-date-input>
                            </div>
                        </td>
                        <!-- Delta -->
                        <td class="border-b border-border px-4 py-4">
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
    </app-drop-down-section>

    <!----------------------------------------------------------------------------->
    <!-- Admin Notes -->
    <app-drop-down-section title="{{ 'invoice.admin_notes' | transloco }}"
        titleIcon="assets/icons/admin/note-black.svg">
        <!-- Actions-->
        <app-edit-cancel-button header-actions [isEditing]="isEditingInvoiceData" [isSaving]="savingInvoice"
            (edit)="editInvoiceData()" (cancel)="cancelEditInvoiceData()"
            (save)="saveEditInvoiceData()"></app-edit-cancel-button>

        <div class="w-full self-center p-4">
            <app-textarea-input labelText="{{ 'invoice.labels.admin_notes' | transloco }}" inputId="adminNotes"
                [(textValue)]="adminNotesInput" [errorMessage]="adminNotesInputError"
                placeholder="{{ 'invoice.placeholders.admin_notes' | transloco }}"
                boxHeight="min-h-[100px] max-h-[200px]" [isDisabled]="!isEditingInvoiceData">
            </app-textarea-input>
        </div>
    </app-drop-down-section>

    <!----------------------------------------------------------------------------->
    <!-- File Details -->
    <app-drop-down-section title="{{ 'admin.check_file_details' | transloco }}"
        titleIcon="assets/icons/admin/file-question-black.svg" (openedChange)="onFileSummaryOpen($event)">

        <div class="flex flex-col gap-2 w-full p-4">
            <p class="font-semibold text-md">{{ 'admin.file_id' | transloco }}: <span
                    class="font-normal">{{invoice?.file?.id || ''}}</span></p>
        </div>

        <div class="card w-full p-4 flex flex-col gap-2">
            <!-- JSON Generator -->
            <p class="font-bold mobile:text-sm">{{ 'admin.json_generator' | transloco }}
            </p>

            <div class="flex gap-2 flex-wrap">
                <div class="h-[50px] min-w-[150px] max-w-[300px]">
                    <app-custom-button buttonText="{{ 'admin.copy' | transloco }}" (buttonClick)="copyJson()"
                        backgroundColor="bg-purple-600" textColor="text-white" borderColor="border:bg-purple-600"
                        hoverBorderColor="border:bg-purple-700" hoverBackgroundColor="hover:bg-purple-700"
                        leadingIcon="assets/icons/copy-white.svg"></app-custom-button>
                </div>

                <div class="h-[50px] min-w-[150px] max-w-[300px]">
                    <app-custom-button buttonText="{{ 'shared.download' | transloco }}" (buttonClick)="downloadJson()"
                        backgroundColor="bg-purple-600" textColor="text-white" borderColor="border:bg-purple-600"
                        hoverBorderColor="border:bg-purple-700" hoverBackgroundColor="hover:bg-purple-700"
                        leadingIcon="assets/icons/download-white.svg">
                    </app-custom-button>
                </div>
            </div>

            @if(loadingFileSummary)
            {
            <!-- Shimmer -->
            <div class="skeleton h-12 w-full"></div>
            <div class="skeleton h-12 w-full"></div>
            <div class="skeleton h-12 w-full"></div>
            <div class="skeleton h-12 w-full"></div>
            }
            @else {
            <app-file-details-view [fileDetailsResponse]="fileDetailsResponse" [toast]="toast"></app-file-details-view>
            }
        </div>
    </app-drop-down-section>
</div>